<template>
    <div class="ttn-block">
        <div class="ttn-block-item ttn-block-item-copyable">
            <span class="font-weight-semibold ttn-number">{{ companyNumber }}</span>
            <i :class="copied ? 'icon-checkmark3 ttn-copy-icon ttn-copy-icon--done' : 'icon-copy3 ttn-copy-icon'" :title="$t('labels.copy_ttn')" @click.stop="copyToClipboard"></i>
        </div>
        <div class="ttn-block-item ttn-block-item-border" @click.stop="openFile(stickerFile)" v-if="stickerFile">
            <i class="icon-barcode2 font-size-12px"></i>
        </div>
        <div class="ttn-block-item ttn-block-item-border" @click.stop="openFile(waybillFile)" v-if="waybillFile">
            <i class="icon-file-text2 font-size-12px"></i>
        </div>
    </div>
</template>
<script>
export default {
    name: 'DeliveryTtnBlock',
    props: {
        companyNumber: {
            type: String,
            default: null
        },
        stickerFile: {
            type: Object,
            default: null
        },
        waybillFile: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            copied: false
        }
    },
    methods: {
        copyToClipboard() {
            navigator.clipboard.writeText(this.companyNumber)
            this.copied = true;
            setTimeout(() => this.copied = false, 1000);
        },
        openFile(file) {
            if (!file) return;
            window.open(file.url, '_blank');
        }
    }
}
</script>
<style scoped>
.ttn-block {
    align-items: center;
    align-self: flex-start;
    border: 1px solid #ddd;
    border-radius: 4px;
    overflow: hidden;
    display: inline-flex;
}
.ttn-block-item {
    padding: 2px 6px;
    font-size: 12px;
    line-height: 18px;
    white-space: nowrap;
}
.ttn-block-item-border {
    border-left: 1px solid #ddd;
    cursor: pointer;
}
.ttn-block-item-border:hover {
    background: #f5f5f5;
}
.ttn-block-item-copyable {
    position: relative;
    width: 130px;
}
.ttn-copy-icon {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    background: rgba(255, 255, 255, 0.85);
    color: #555;
    cursor: pointer;
    font-size: 13px;
    transition: opacity 0.15s;
}
.ttn-block-item-copyable:hover .ttn-copy-icon {
    opacity: 1;
}
.ttn-copy-icon:hover {
    color: #111;
}
.ttn-copy-icon--done {
    opacity: 1;
}
.font-size-12px {
    font-size: 12px;
}
.ttn-number {
    padding-left: 10px;
    padding-right: 10px;
}
</style>
